import { render, staticRenderFns } from "./CardHumorQuestions.vue?vue&type=template&id=05f12954&scoped=true&"
import script from "./CardHumorQuestions.vue?vue&type=script&lang=js&"
export * from "./CardHumorQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CardHumorQuestions.vue?vue&type=style&index=0&id=05f12954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f12954",
  null
  
)

export default component.exports